import * as React from 'react';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Login from './pages/Login';
import './App.css'
import { Docs } from './pages/docs/Docs';
import Schema from './pages/schema/Schema';
import Model from './pages/model/Model';
import { compose } from 'redux';
import { withAccessControlModel } from './hoc/withAccessControlModel';
import { withAddOrUpdateModelData } from './hoc/withAddOrUpdateModelData';
import { withAddOrUpdateTrainedModel } from './hoc/withAddOrUpdateTrainedModel';
import { withDuplicateTrainedModel } from './hoc/withDuplicateTrainedModel';
import { withErrorMessage } from './hoc/withErrorMessage';
import { withRunModel } from './hoc/withRunModel';
import { withUploadOnnxModel } from './hoc/withUploadOnnxModel';
import { withCalculateMetricsModal } from './hoc/withCalculateMetricsModal';
import Settings from './pages/settings/Settings';
import { AppBarComponent, AppBarHeight } from './components/AppBar';
import { Box, CircularProgress, Stack } from '@mui/material';
import LeftPanel from './components/LeftPanel/LeftPanel';
import { useAuth } from './hooks/useAuth';
import { withAddOrUpdateSchema } from './hoc/withAddOrUpdateSchema';
import { Palette, Sizes } from './@shared/palette';
import Subscription from './pages/subscription/Subscription';

import { getAppConfig, getIsAuthorized } from './reducers/main/mainReducer';
import { useSelector } from 'react-redux';
import { withSupport } from './hoc/withSupport';
import { LogoWithText } from './components/icons/LogoWithText';
import { withSubscription } from './hoc/withSubscription';
import { Route, Routes } from 'react-router-dom';


const App = () => {
    const { isInitialized, isUserLoading, shouldHideComponents } = useAuth();
    const user = useSelector(getIsAuthorized);
    const config = useSelector(getAppConfig);
    const [hasLoadedAnalytics, setHasLoadedAnalytics] = React.useState<boolean>(false);
    
    React.useEffect(() => {
        if (config && config.isGoogleAnalyticsEnabled && !hasLoadedAnalytics) {
            setHasLoadedAnalytics(true);
            loadAnalytics();
        }
    }, [config, hasLoadedAnalytics]);

    const version = process.env.REACT_APP_VERSION ?? "0.0.0.0";

    if (!isInitialized || isUserLoading) {
        return <Box sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%"
        }}>
            <LogoWithText />
            <CircularProgress sx={{ color: Palette.btnPrimary }} />
        </Box>
    }

    return <>
        {!shouldHideComponents && user && <AppBarComponent />}
        <Stack direction="row" spacing={2}>
            {!shouldHideComponents && user && <LeftPanel />}
            <Box sx={{
                width: !shouldHideComponents ? "calc(100% - 300px)" : "100%",
                minWidth: "680px",
                overflowY: "auto",
                minHeight: !shouldHideComponents ? `calc(100vh - ${AppBarHeight}px)` : "100vh",
                maxHeight: !shouldHideComponents ? `calc(100vh - ${AppBarHeight}px)` : "100vh",
            }}><Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/auth' element={<Auth />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/Documentation' element={<Docs />} />
                    <Route path='/Settings' element={<Settings />} />
                    <Route path='/Subscription' element={<Subscription />} />
                    <Route path='/:schemaId' element={<Schema />} />
                    <Route path='/:schemaId/:modelId' element={<Model />} />
                </Routes>
            </Box>
            <Box
                sx={{
                    position: "absolute",
                    bottom: "15px",
                    margin: "0",
                    color: Palette.textColorSecondary,
                    fontSize: Sizes.textSecondary
                }}
            >{version}-beta</Box>
        </Stack >
    </>
}
export default compose<React.ComponentType>(
    withSupport,
    withAddOrUpdateTrainedModel,
    withAddOrUpdateModelData,
    withRunModel,
    withCalculateMetricsModal,
    withUploadOnnxModel,
    withAccessControlModel,
    withDuplicateTrainedModel,
    withErrorMessage,
    withAddOrUpdateSchema,
    withSubscription
)(App);

const loadAnalytics = () => {
  const script1 = document.createElement("script");
  script1.async = true;
  script1.src = "https://www.googletagmanager.com/gtag/js?id=G-RDQ2NK12DX";
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-RDQ2NK12DX');
  `;
  document.head.appendChild(script2);
}